<script>
  import AccidentBarchart from "./accidentBarchart.svelte";
  import HorizontalBarchart from "./horizontalBarchart.svelte";
  import { VIEW_OPTION } from "./../data/costsofmeasures.js";

  export let data;
  export let Y;
  export let selectedView;

  const {
    alcoholCheckpoint,
    barClosing,
    alcoholBan,
    curfew,
    lockdown,
    cost,
    benefit,
    actualAccident,
    expectedAccident,
  } = data;
</script>

<style lang="scss">
  .status {
    width: 20px;
    margin: 0 auto;
  }

  .check {
    position: relative;
    top: -10px;

    &::before {
      content: "";
      width: 4px;
      height: 12px;
      border-right: 2px solid lightgreen;
      border-bottom: 2px solid lightgreen;
      transform: rotate(45deg);
      position: absolute;
      left: 50%;
    }
  }

  .cross {
    position: relative;
    top: -10px;

    &::before {
      content: "";
      width: 12px;
      height: 12px;
      border-right: 2px solid salmon;
      transform: rotate(45deg);
      position: absolute;
      left: calc(50% - 7px);
    }

    &::after {
      content: "";
      width: 12px;
      height: 12px;
      border-left: 2px solid salmon;
      transform: rotate(-45deg);
      position: absolute;
      left: 50%;
    }
  }

  .cell {
    flex: 0 0 10%;
    position: relative;

    &:last-child {
      flex: 0 0 50%;
    }
  }
</style>

<div class="cell">
  <div class="status {alcoholCheckpoint ? 'check' : 'cross'}" />
</div>
<div class="cell">
  <div class="status {barClosing ? 'check' : 'cross'}" />
</div>
<div class="cell">
  <div class="status {alcoholBan ? 'check' : 'cross'}" />
</div>
<div class="cell">
  <div class="status {curfew ? 'check' : 'cross'}" />
</div>
<div class="cell">
  <div class="status {lockdown ? 'check' : 'cross'}" />
</div>
<div class="cell">
  {#if selectedView === VIEW_OPTION.accident}
    <AccidentBarchart {actualAccident} {expectedAccident} />
  {:else}
    <HorizontalBarchart {cost} {benefit} {Y} />
  {/if}
</div>
